module.exports = __webpack_public_path__ + "static/media/ios-football.4cd5e4dd.svg";